import type { EpgDateEx } from '~/entities/epg/dates'
import type { EpgDateExStamped } from './index.h'

import { toTimestamp } from '~/entities/epg/dates'

/**
 * Add timestamp to dates,
 * because `coveredDays` property in `ProgramList` requires it as `stamp` property
 */
export const toStamped = (date: EpgDateEx): EpgDateExStamped => ({
  ...date,
  stamp: toTimestamp(date),
})
